import { useState } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, NavLink } from "react-router-dom";
import "./Header.css";
import ShinyLogo from "../../Components/Assets/transperent-logo.png";
import { IoCall } from "react-icons/io5";
import { IoIosMail } from "react-icons/io";
import { FaFacebook, FaInstagram, FaGoogle, FaPhoneAlt } from "react-icons/fa";
import SEO from '../SEO/SEO';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const handleToggle = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };
  return (
    <>      <SEO />
    <header className="main-header position-fixed w-100 z-3">

      {/* Topbar */}
      <div className="topbar text-white py-2 ">
        <div className="container d-flex flex-column flex-md-row justify-content-between align-items-center text-center">
          <div className="d-none  d-sm-block">
            <strong>Your trusted cleaning solution in Adelaide.</strong>
          </div>
          <div className="d-flex align-items-center gap-3 flex-wrap justify-content-center mt-2 mt-md-0">
            <Link
              to="tel:0406958557"
              className="text-decoration-none text-white d-inline-flex align-items-center gap-2"
            >
              <FaPhoneAlt /> <strong>+61 406 958 557 </strong>
            </Link>
            <div className="d-flex align-items-center gap-2 ">
              <IoIosMail className="icon text-white" />
              <Link
                to="mailto:info@shinycleaner.com"
                className="text-decoration-none text-white"
              >
                <strong>info@shinycleaner.com</strong>
              </Link>
            </div>

            <div className="social-icons-top d-flex align-items-center gap-2 d-none  d-sm-block">
              <Link
                to="https://www.facebook.com/shinycleaningofficial"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link-top"
              >
                <FaFacebook className="social-icon-top" />
              </Link>
              <Link
                to="https://www.instagram.com/shinycleaningofficial/"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link-top"
              >
                <FaInstagram className="social-icon-top" />
              </Link>
              <Link
                to="https://www.google.com/maps/place/Shiny+Cleaning/@-34.8706926,138.6782561,17z/data=!3m1!4b1!4m6!3m5!1s0xa635f2ddcbe88963:0x4a7a383a4f425b24!8m2!3d-34.8706926!4d138.6782561!16s%2Fg%2F11vbsb9g4l?hl=en-IN&entry=ttu&g_ep=EgoyMDI1MDYzMC4wIKXMDSoASAFQAw%3D%3D/"
                target="_blank"
                rel="noreferrer"
                className="social-icon-link-top"
              >
                <FaGoogle className="social-icon-top" />
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Glass Navbar */}
      <nav className="navbar glass-navbar shadow-sm navbar-expand-lg">
        <div className="container d-flex align-items-center justify-content-between">
          <NavLink className="navbar-brand" to="/">
            <img src={ShinyLogo} alt="Shiny Logo" className="p-1" />
          </NavLink>

          {/* Toggle Icon */}
          <button
            onClick={handleToggle}
            className="navbar-toggler border-0 bg-transparent text-dark"
            type="button"
            aria-label="Toggle navigation"
          >
            {menuOpen ? (
              <FaTimes className="fs-3" />
            ) : (
              <FaBars className="fs-3" />
            )}
          </button>

          {/* Navbar Menu */}
          <div
            className={`collapse navbar-collapse ${
              menuOpen ? "show d-block" : "d-none d-lg-block"
            }`}
          >
            <ul className="navbar-nav ms-auto gap-lg-3 text-center text-lg-start">
              <li className="nav-item">
                <NavLink className="nav-link" to="/" onClick={closeMenu}>
                  Home
                </NavLink>
              </li>

              <li className="nav-item dropdown custom-dropdown">
                <span
                  className="nav-link dropdown-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  Services
                </span>
                <ul className="dropdown-menu custom-menu">
                  <li>
                    <NavLink
                      className="custom-item"
                      to="/adelaide-service"
                      onClick={closeMenu}
                    >
                      Adelaide
                    </NavLink>
                  </li>
                  {/* Melbourne - Hidden
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                  <li>
                    <NavLink
                      className="custom-item"
                      to="/melbourne-service"
                      onClick={closeMenu}
                    >
                      Melbourne
                    </NavLink>
                  </li>
                  */}
                </ul>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/about-us/" onClick={closeMenu}>
                  About Us
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/faq-page" onClick={closeMenu}>
                  FAQ
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/blog" onClick={closeMenu}>
                  Blog
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/contact-us"
                  onClick={closeMenu}
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    </>
  );
};

export default Header;
